import { api } from "../api/api";

const errorHandler = (error) => {
  if (error?.code?.trim() == "ERR_NETWORK") {
    throw new Error(
      "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
    );
  } else {
    throw new Error(error?.response?.data?.title);
  }
};

export const ItemAndStoreService = async (values, screenName) => {
  try {
    let response;
    const url =
      screenName?.toLowerCase() === "item"
        ? "/api/ItemXRefs"
        : "/api/ShipToXRefs";

    response = await api.get(url, {
      params: values 
    });
    return response?.data?.result?.result || [];
  } catch (error) {
    errorHandler();
  }
};
